import { GridActionsCellItem } from '@mui/x-data-grid'

export const GridActions = (props: any) => {
  return <GridActionsCellItem label={''} {...props} />
}
